import { getRouteApi } from '@tanstack/react-router'
import { routes } from 'commons/constants/routes'

import { ContactMetadataManage } from './ContactMetadataManage'

const routeApi = getRouteApi('/_app/relationships/$id/contact/edit/$contactId')

export const ContactEditDialogContainer = () => {
  const { contactId, id } = routeApi.useParams()
  const { contactName } = routeApi.useSearch()
  const navigate = routeApi.useNavigate()

  const onClose = () =>
    navigate({ to: routes.bank.relationships.details, params: { id: id.toString() }, hash: 'contacts' })

  return (
    <ContactMetadataManage
      companyId={Number(id)}
      contactId={Number(contactId)}
      contactName={contactName}
      onClose={onClose}
      onSuccess={() => onClose()}
      isContactCreateFromRelationships={false}
    />
  )
}
